<div data-test="customFieldDefinitionModal">
  <div mat-dialog-title class="pt-8">{{ (isEdit ? 'customFieldDefinitions.edit' : 'customFieldDefinitions.create') | translate }}</div>
  <hr class="divider">
  <mat-dialog-content>
    <form [formGroup]="form" class="px-6 py-4 flex flex-col">
      <!-- target, key y dataType no se pueden cambiar una vez creada: en edicion se muestran como texto -->
      <div *ngIf="isEdit; else editableFixedFields" class="flex flex-col" data-test="customFieldDefinitionFixedFields">
        <div class="flex space-x-4 mb-4">
          <div class="w-1/2 body-b2">
            <span class="label">{{ 'customFieldDefinitions.target' | translate }}:&nbsp;</span>
            <span data-test="customFieldDefinitionTargetText">{{ ('customFieldDefinitions.targets.' + data.definition?.target) | translate }}</span>
          </div>
          <div class="w-1/2 body-b2">
            <span class="label">{{ 'customField.dataType' | translate }}:&nbsp;</span>
            <span data-test="customFieldDefinitionDataTypeText">{{ ('customField.dataTypes.' + data.definition?.dataType) | translate }}</span>
          </div>
        </div>
        <div class="flex space-x-4">
          <app-input [type]="'text'" [control]="form.get('label')" [label]="'customFieldDefinitions.label' | translate" [placeholder]="'customFieldDefinitions.label' | translate" class="w-1/2" data-test="customFieldDefinitionLabel"></app-input>
          <div class="flex flex-col w-1/2">
            <span class="label field-label mb-1">{{ 'customFieldDefinitions.key' | translate }}</span>
            <span class="body-b2 fixed-value break-all" data-test="customFieldDefinitionKeyText">{{ data.definition?.key }}</span>
          </div>
        </div>
      </div>

      <ng-template #editableFixedFields>
        <div class="flex space-x-4">
          <div class="flex flex-col w-1/2">
            <mat-label class="label mb-1" [ngClass]="{'text-disabled': form.get('target')?.disabled}">{{ 'customFieldDefinitions.target' | translate }}</mat-label>
            <mat-form-field class="caption-c1">
              <mat-select formControlName="target" data-test="customFieldDefinitionTarget">
                <mat-option *ngFor="let target of TARGETS" [value]="target">{{ ('customFieldDefinitions.targets.' + target) | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex flex-col w-1/2">
            <mat-label class="label mb-1">{{ 'customField.dataType' | translate }}</mat-label>
            <mat-form-field class="caption-c1">
              <mat-select formControlName="dataType" (selectionChange)="selectDataType()" data-test="customFieldDefinitionDataType">
                <mat-option *ngFor="let dataType of DATA_TYPES" [value]="dataType">{{ ('customField.dataTypes.' + dataType) | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="flex space-x-4">
          <app-input [type]="'text'" [control]="form.get('label')" [label]="'customFieldDefinitions.label' | translate" [placeholder]="'customFieldDefinitions.label' | translate" class="w-1/2" data-test="customFieldDefinitionLabel"></app-input>
          <app-input [type]="'text'" [control]="form.get('key')" [label]="'customFieldDefinitions.key' | translate" [placeholder]="'customFieldDefinitions.key' | translate" [hint]="'customFieldDefinitions.keyHint' | translate" (input)="onKeyInput()" class="w-1/2" data-test="customFieldDefinitionKey"></app-input>
        </div>
      </ng-template>

      <div *ngIf="form.get('target')?.value === TARGET.Actor" class="flex flex-col">
        <mat-label class="label mb-1">{{ 'customFieldDefinitions.actorSubtypes' | translate }}</mat-label>
        <mat-form-field class="caption-c1">
          <mat-select formControlName="actorSubtypes" multiple [placeholder]="'customFieldDefinitions.allActorSubtypes' | translate" data-test="customFieldDefinitionActorSubtypes">
            <mat-option *ngFor="let subtype of ACTOR_SUBTYPES" [value]="subtype">{{ ('objects.' + subtype) | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="form.get('target')?.value === TARGET.Place" class="flex flex-col">
        <mat-label class="label mb-1">{{ 'customFieldDefinitions.placeTypes' | translate }}</mat-label>
        <mat-form-field class="caption-c1">
          <mat-select formControlName="placeTypes" multiple [placeholder]="'customFieldDefinitions.allPlaceTypes' | translate" data-test="customFieldDefinitionPlaceTypes">
            <mat-option *ngFor="let placeType of PLACE_TYPES" [value]="placeType">{{ ('objects.' + placeType) | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="form.get('dataType')?.value === DATA_TYPE.Select" class="flex flex-col" data-test="customFieldDefinitionOptions">
        <mat-label class="label mb-2">{{ 'customFieldDefinitions.options' | translate }}</mat-label>
        <div *ngFor="let option of (options.controls | cast); let i = index" class="flex items-start" [ngClass]="{'opacity-60': option.get('archived')?.value}" data-test="customFieldDefinitionOptionRow">
          <app-input [type]="'text'" [control]="option.get('label')" [label]="'customFieldDefinitions.optionLabel' | translate" [placeholder]="'customFieldDefinitions.optionLabel' | translate" class="flex-1 mr-4" data-test="customFieldDefinitionOption"></app-input>
          <app-input *ngIf="!option.get('saved')?.value; else savedKey" [type]="'text'" [control]="option.get('key')" [label]="'customFieldDefinitions.optionKey' | translate" [placeholder]="'customFieldDefinitions.optionKey' | translate" class="flex-1 mr-4" data-test="customFieldDefinitionOptionKey"></app-input>
          <ng-template #savedKey>
            <div class="flex flex-col flex-1 mr-4">
              <span class="label field-label mb-1">{{ 'customFieldDefinitions.optionKey' | translate }}</span>
              <span class="body-b2 fixed-value break-all" data-test="customFieldDefinitionOptionKeyText">
                {{ option.get('key')?.value }}
                <span *ngIf="option.get('archived')?.value" class="caption-c2 secondary-text ml-2" data-test="customFieldDefinitionOptionArchived">{{ 'customFieldDefinitions.archived' | translate }}</span>
              </span>
            </div>
          </ng-template>
          <div class="option-action w-28 flex items-center justify-end">
            <!-- Las opciones guardadas no se borran: se archivan. Solo las nuevas se pueden quitar -->
            <app-button-link *ngIf="option.get('saved')?.value; else removeOption"
              (click)="toggleOptionArchived(option)"
              [text]="(option.get('archived')?.value ? 'customFieldDefinitions.unarchive' : 'customFieldDefinitions.archive') | translate"
              [iconLeft]="option.get('archived')?.value ? 'unarchive' : 'archive'"
              [style]="option.get('archived')?.value ? 'primary' : 'warn'"
              [attr.data-test]="option.get('archived')?.value ? 'unarchiveCustomFieldDefinitionOption' : 'archiveCustomFieldDefinitionOption'"></app-button-link>
            <ng-template #removeOption>
              <app-button-link (click)="deleteFormElement(options, i)" [disabled]="options.length <= 1" [style]="'warn'" iconLeft="trash" data-test="removeCustomFieldDefinitionOption"></app-button-link>
            </ng-template>
          </div>
        </div>
        <app-button-link (click)="addOption()" text="{{ 'customFieldDefinitions.addOption' | translate }}" [style]="'primary'" iconLeft="plus-circle" data-test="addCustomFieldDefinitionOption"></app-button-link>
      </div>

      <mat-checkbox formControlName="alwaysShow" color="primary" class="mt-4" data-test="customFieldDefinitionAlwaysShow">
        <span class="body-b2">{{ 'customFieldDefinitions.alwaysShow' | translate }}</span>
      </mat-checkbox>
      <small class="caption-c2 secondary-text ml-10">{{ 'customFieldDefinitions.alwaysShowHint' | translate }}</small>
    </form>
  </mat-dialog-content>
  <hr class="divider">

  <mat-dialog-actions>
    <div class="flex w-full items-center justify-between">
      <app-button-link (click)="close()" text="{{ 'buttons.cancel' | translate }}" [style]="'warn'"></app-button-link>
      <app-button-secondary (click)="save()" [disabled]="saving" data-test="saveCustomFieldDefinition">{{ 'buttons.save' | translate }}</app-button-secondary>
    </div>
  </mat-dialog-actions>
</div>
